'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

const DemoRequestSticky: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showSticky, setShowSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.querySelector('#hero');
      if (heroSection) {
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        setShowSticky(heroBottom < 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const contactInfo = [
    {
      icon: 'PhoneIcon',
      label: 'Call Us',
      value: '(+91) 9446065047',
      href: 'tel:+919446065047',
    },
    {
      icon: 'EnvelopeIcon',
      label: 'Email Us',
      value: 'contact@sensivisionhealth.com',
      href: 'mailto:contact@sensivisionhealth.com',
    },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-[150]">
      {!isExpanded ? (
        <button
          onClick={() => setIsExpanded(true)}
          className="bg-accent text-accent-foreground px-6 py-4 rounded-lg shadow-cta hover:bg-accent/90 transition-all duration-250 ease-out flex items-center space-x-3 font-cta font-bold text-lg"
          aria-label="View contact information"
        >
          <Icon name="PhoneIcon" size={24} />
          <span>Contact Us</span>
        </button>
      ) : (
        <div className="bg-card rounded-lg shadow-card w-[380px] max-w-[calc(100vw-48px)]">
          <div className="flex items-center justify-between p-4 border-b border-border">
            <h3 className="text-lg font-bold font-heading text-foreground">
              Contact Information
            </h3>
            <button
              onClick={() => setIsExpanded(false)}
              className="p-1 rounded-lg hover:bg-muted transition-colors duration-250 ease-out"
              aria-label="Close contact info"
            >
              <Icon name="XMarkIcon" size={20} className="text-foreground" />
            </button>
          </div>

          <div className="p-6 space-y-4">
            {contactInfo.map((contact, index) => (
              <a
                key={index}
                href={contact.href}
                className="flex items-start space-x-4 p-4 rounded-lg hover:bg-muted transition-colors duration-250 ease-out group"
              >
                <div className="p-3 bg-primary/10 rounded-lg group-hover:bg-primary/20 transition-colors">
                  <Icon name={contact.icon as any} size={24} className="text-primary" />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-muted-foreground mb-1">
                    {contact.label}
                  </p>
                  <p className="text-base font-semibold text-foreground group-hover:text-primary transition-colors">
                    {contact.value}
                  </p>
                </div>
              </a>
            ))}

            <div className="pt-4 border-t border-border">
              <p className="text-sm text-muted-foreground text-center">
                Available 24/7 for urgent inquiries
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DemoRequestSticky;